module.exports = __webpack_public_path__ + "img/share.bacc082a.png";